
//获取随机字符串由数字和大小写字母组成
//传入num为长度
const getRandomAlph = (params)=>{
    let allChats = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    let randomIndex=0;
    let lastStr=""
    let num = params.num
    for (let i = 0; i<num ; i++){
        randomIndex = Math.random() * allChats.length
        randomIndex = Math.floor(randomIndex)
        lastStr =lastStr+ allChats.charAt(randomIndex);
    }
    return lastStr;
}
// console.log(getRandomAlph(5))







export {
    getRandomAlph
} 